var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    _vm.isDisabled ? `${_vm.styles} disabled ${_vm.size}` : `${_vm.styles} ${_vm.size}`,
    { 'dark-mode': _vm.darkMode },
  ],style:(_vm.styleObject),attrs:{"disabled":_vm.isDisabled,"type":_vm.type}},[(_vm.hasLoader)?_c('div',{staticClass:"spinner",class:{ disabled: _vm.isDisabled }}):_c('div',{staticClass:"content",class:!!_vm.iconLeft || !!_vm.iconRight ? 'no-icon' : ''},[(!!_vm.iconLeft)?_c('i',{class:_vm.iconLeft}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" "),(!!_vm.iconRight)?_c('i',{class:_vm.iconRight}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }